import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Dropdown, Menu } from '@storable/canaveral-components';
import styles from './styles.scss';

const propTypes = {
  componentClass: PropTypes.element.isRequired,
  title: PropTypes.string,
  type: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

const defaultProps = {
  title: undefined,
};

const TypesDropdown = ({
  componentClass: MenuItem,
  title,
  type: {
    name,
  },
  types,
  ...rest
}) => {
  const toggle = (
    <Dropdown.Toggle>
      {name}
    </Dropdown.Toggle>
  );

  const header = title && (
    <Menu.Header title={title} />
  );

  return (
    <Dropdown
      toggle={toggle}
      className={styles.dropdown}
    >
      <Menu
        header={header}
        className={styles.menu}
      >
        {types.map(otherType => (
          <MenuItem
            key={otherType.id}
            type={otherType}
            {...rest}
          />
        ))}
      </Menu>
    </Dropdown>
  );
};

TypesDropdown.propTypes = propTypes;
TypesDropdown.defaultProps = defaultProps;

TypesDropdown.fragments = {
  pageType: gql`
    fragment TypesDropdownPageType on PageType {
      id
      name
    }
  `,
  siteType: gql`
    fragment TypesDropdownSiteType on SiteType {
      id
      name
    }
  `,
};

export default TypesDropdown;
